var map = {
	"./far1.png": "72a2",
	"./far1_active.png": "e321",
	"./far2.png": "3d72",
	"./far2_active.png": "d4b7",
	"./far3.png": "5fc4",
	"./far3_active.png": "28c5",
	"./far4.png": "7727",
	"./far4_active.png": "1607"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e33c";